var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.471,15.89c0.074,0.074,0.161,0.129,0.253,0.166c0.093,0.039,0.192,0.061,0.291,0.061c0.192,0,0.384-0.073,0.53-0.22 l4.105-4.105c0.293-0.293,0.293-0.768,0-1.061s-0.768-0.293-1.061,0l-2.836,2.836V5.25c0-0.414-0.335-0.75-0.75-0.75 s-0.75,0.336-0.75,0.75v8.302l-2.821-2.821c-0.293-0.293-0.768-0.293-1.061,0s-0.293,0.768,0,1.061L11.471,15.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.489,18H6.51c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75h10.979c0.414,0,0.75-0.336,0.75-0.75 S17.903,18,17.489,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download-arrow.4dc36a20787a3622884705533d2d98dd.svg";
export { ForwardRef as ReactComponent };